import {
    trackCreateSurveyClick,
    trackCreateSurveyFromScratchClick,
    trackCreateSurveyFromTemplateClick,
    trackPublishButtonClick,
    trackUseTemplateClick,
    trackPreviewTemplateClick,
    trackHelpCenterClick,
    trackNavigationClick,
    trackMoveToDraftClick,
    trackDuplicateSurveyClick,
    trackViewAnalyticsClick,
    trackEditSurveyClick,
} from '@/utils/analytics'

// Hook for tracking button clicks
export const useAnalyticsClick = () => {
    const trackClick = (
        action:
            | 'create_survey'
            | 'create_from_scratch'
            | 'create_from_template'
            | 'publish'
            | 'use_template'
            | 'preview_template'
            | 'help_center'
            | 'navigation'
            | 'move_to_draft'
            | 'duplicate_survey'
            | 'view_analytics'
            | 'edit_survey',
        options?: {
            templateName?: string
            surveyId?: string
            surveyName?: string
            destination?: string
            method?: 'modal' | 'scratch' | 'template'
        }
    ) => {
        const { templateName, surveyId, surveyName, destination, method } =
            options || {}
        switch (action) {
            case 'create_survey':
                trackCreateSurveyClick(method || 'modal')
                break
            case 'create_from_scratch':
                trackCreateSurveyFromScratchClick()
                break
            case 'create_from_template':
                trackCreateSurveyFromTemplateClick(templateName)
                break
            case 'publish':
                trackPublishButtonClick(surveyId)
                break
            case 'use_template':
                trackUseTemplateClick(templateName)
                break
            case 'preview_template':
                trackPreviewTemplateClick(templateName)
                break
            case 'help_center':
                trackHelpCenterClick()
                break
            case 'navigation':
                trackNavigationClick(destination || '')
                break
            case 'move_to_draft':
                trackMoveToDraftClick(surveyId, surveyName)
                break
            case 'duplicate_survey':
                trackDuplicateSurveyClick(surveyId, surveyName)
                break
            case 'view_analytics':
                trackViewAnalyticsClick(surveyId, surveyName)
                break
            case 'edit_survey':
                trackEditSurveyClick(surveyId, surveyName)
                break
        }
    }

    return { trackClick }
}
